import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_OldBank } from '$Deposits/store/actions/DepositPost'
import { SetDepositOldBank, SetUploadFileErr, RemoveAllReducers } from '$Deposits/store/actions/DepositAction'
import { OldBank_Submit } from '$Deposits/store/actions/DepositEvent'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
const { LivechatClick } = GetParamsData()


class OldBank extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {
        // this.props.RemoveAllReducers(true)
    }


    render() {


        const {
            MethodsActive,
            SetDepositPayments_OldBank,
            SetDepositOldBank,
            OldBank,
            DepositSuccessPage,
            SuccessPage,
            FileModal,
            UploadFileErr,
            SetUploadFileErr,
        } = this.props


        return (

            <>
                {/* <FileModal
                    modalVisible={Boolean(UploadFileErr)}
                    title={'Tải Lên Thất Bại!'}
                    okText={'Tôi Hiểu'}
                    msg={UploadFileErr}
                    onChange={() => { SetUploadFileErr('') }}
                /> */}
                <OldBank
                    MethodsActive={MethodsActive}
                    onChange={() => { SetDepositPayments_OldBank() }}
                    submitBtn={OldBank_Submit}
                    backClick={() => { SetDepositOldBank(); this.props.RemoveAllReducers(true) }}
                />
            </>

        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    DepositSuccessPage: state.DepositSuccessPage,
    UploadFileErr: state.UploadFileErr,
});
const mapDispatchToProps = {
    SetDepositPayments_OldBank: (data) => SetDepositPayments_OldBank(data),
    SetDepositOldBank: (data = false) => SetDepositOldBank(data),
    SetUploadFileErr: (data = '') => SetUploadFileErr(data),
    RemoveAllReducers: (flag) => RemoveAllReducers(flag),
};
export default connect(mapStateToProps, mapDispatchToProps)(OldBank);



